import LoginTemplate from "../_shoru_shared_library/template/LoginTemplate";
import Logo from '../_media/branding/logo.svg';

function Login(props) {

  return (

    <LoginTemplate 
      appName='CastingBot'
      logo={Logo}
      accentColour='#0984e3'
      redirect='/console/overview'
    />

  )

}

export default Login;